import Task from './Task'
import merge from '../functions/merge'
import Date from '../prototypes/Date'

export default merge(Task, {
	entity() {
		return merge(Task.entity(), {
			type: 'survey',
			details: {
				date: (new Date()).format('Y-m-d'),
				address: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				dest: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				area: '',
				//type: '3',
				//purpose: 'quote',
				duration: 60
			}
		});
	}
});